import React, { useState } from "react";
import { toast } from "sonner";
import { DownloadSimple } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../lib/api";

export const AvailabilityCsvButton = () => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/admin/availability.csv", { responseType: "blob", timeout: 120000 });
      const url = URL.createObjectURL(data);
      const a = Object.assign(document.createElement("a"), { href: url, download: `availability-${new Date().toISOString().slice(0, 10)}.csv` });
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't build the availability file. Please try again.");
    } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={download} disabled={busy} data-testid="availability-csv-btn"
      className="btn-secondary inline-flex items-center gap-2 disabled:opacity-60">
      <DownloadSimple size={16} /> {busy ? "Preparing…" : "Download availability (CSV)"}
    </button>
  );
};
